export default __webpack_public_path__ + "logo-wordmark-navy.png";